import React, { useRef, useState, useEffect } from "react";
import SignaturePad from "react-signature-canvas";
import {
  Button,
  Container,
  Typography,
  Snackbar,
  Backdrop,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import { text } from "../../utils/Multilanguage";
import "./Signature.css";
import Axios from "axios";
import MuiAlert from "@material-ui/lab/Alert";
import config from "../../config";

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function Signature(props) {
  const { handleClose, title } = props;
  const [isloading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [errorSnackbar, setErrorSnackbar] = useState({
    isOpen: false,
    message: "Error",
  });
  const sigCanvas = useRef({});
  const classes = useStyles();

  const clear = () => {
    sigCanvas.current.clear();
  };

  useEffect(() => {
    if (response !== null) {
      if (response.code === "error") {
        setErrorSnackbar({
          isOpen: true,
          message: response.description,
        });
      } else {
        handleClose();
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      setErrorSnackbar({
        isOpen: true,
        message: "Error",
      });
    }
  }, [error]);

  const save = () => {
    setIsLoading(true);
    const imageSignaturePng = sigCanvas.current
      .getTrimmedCanvas()
      .toDataURL("image/png");

    let formData = new FormData();
    formData.append("token", localStorage.getItem("token"));
    formData.append("signature", imageSignaturePng);

    Axios.post(
      `${config.API_URL}/_services/set_signature.php`,
      formData
    )
      .then((response) => {
        setResponse(response.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err.response.data);
        setIsLoading(false);
      });
  };

  return (
    <Container
      style={{
        position: "fixed",
        height: "100%",
        paddingLeft: "5px",
        paddingRight: "5px",
        paddingTop: "5px",
      }}
    >
      <Typography variant='h6'>{text(title)}</Typography>
      <SignaturePad ref={sigCanvas} canvasProps={{ className: "signature" }} />
      <div className='buttons'>
        <Button variant='contained' onClick={clear} disableFocusRipple={false}>
          {text("Clear")}
        </Button>
        <Button variant='contained' onClick={save} disableFocusRipple={true}>
          {text("Save")}
        </Button>
      </div>
      <Snackbar
        open={errorSnackbar.isOpen}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert severity='error'>{errorSnackbar.message}</Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={isloading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </Container>
  );
}
